// extracted by css-extract-rspack-plugin
export default {"wrapper":"_7ddf07f6","imageWrapper":"_546a51f1","bottomWrapper":"_40b67bf9","content":"_df3db02c","iconsContainer":"_80cad0ba","iconWrapper":"_9f9b2f5d","icon":"_88826f4e"};